module.exports = __webpack_public_path__ + "img/blood-unit-popup.744d36f2.svg";